import React, { Dispatch, SetStateAction, useState } from 'react';
import dayjs from 'dayjs';
import { FilterParams } from '../../../../interfaces/Filter';
import Input from '../../../../components/input/Input';
import { DatePicker, DatePickerProps, Dropdown, MenuProps, Select } from 'antd';
import Button from '../../../../components/button/Button';
import CustomModal from '../../../../components/CustomModal';
import { FilterIcon } from '../../../../components/icons';

const FilterTreasuryTransactions = ({
    transactionFilterOptions,
    setTransactionFilterOptions
}: {
    transactionFilterOptions: FilterParams;
    setTransactionFilterOptions: Dispatch<SetStateAction<FilterParams>>;
}) => {
    const [tempFilterOptions, setTempFilterOptions] = useState<FilterParams>(
        transactionFilterOptions
    );

    const onChangeFrom: DatePickerProps['onChange'] = (date) => {
        setTempFilterOptions({
            ...tempFilterOptions,
            from: date?.format('YYYY-MM-DD HH:mm:ss')
        });
    };

    const onChangeTo: DatePickerProps['onChange'] = (date) => {
        setTempFilterOptions({
            ...tempFilterOptions,
            to: date?.format('YYYY-MM-DD HH:mm:ss')
        });
    };
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);

    const handleApply = () => {
        setTransactionFilterOptions(tempFilterOptions);
        setDropdownVisible(false);
        setModalVisible(false);
    };

    const items = [
        {
            key: '1',
            label: (
                <p className='text-ebony text-base leading-[20px] pt-4 '>
                    Filter
                </p>
            )
        },
        {
            key: '2',
            label: (
                <div>
                    <label className='text-sm font-medium text-steelBlue  block mb-2'>
                        Account
                    </label>

                    <Input
                        type='text'
                        value={tempFilterOptions?.accountNumber}
                        style={{ height: '40px' }}
                        placeholder='number'
                        onChange={(e) =>
                            setTempFilterOptions({
                                ...tempFilterOptions,
                                accountNumber: e.target.value
                            })
                        }
                    />
                </div>
            )
        },
        {
            key: '3',
            label: (
                <div>
                    <label className='text-sm font-medium text-steelBlue  block mb-2'>
                        Transaction Type
                    </label>

                    <Select
                        style={{ width: '100%' }}
                        value={tempFilterOptions?.type}
                        onChange={(value: string) =>
                            setTempFilterOptions({
                                ...tempFilterOptions,
                                type: value
                            })
                        }
                        options={[
                            {
                                value: 'credit',
                                label: 'Credit'
                            },
                            {
                                value: 'debit',
                                label: 'Debit'
                            }
                        ]}
                        size='large'
                    />
                </div>
            )
        },
        {
            key: '4',
            label: (
                <div className='mt-[16px] lg:mt-0'>
                    <label className='text-sm font-medium text-steelBlue  block'>
                        Amount Range
                    </label>
                    <div className='flex items-center gap-[12px]'>
                        <Input
                            type='number'
                            value={tempFilterOptions?.amountRangeStart}
                            style={{ height: '40px' }}
                            placeholder='Minimum'
                            onChange={(e) =>
                                setTempFilterOptions({
                                    ...tempFilterOptions,
                                    amountRangeStart: Number(e.target.value)
                                })
                            }
                        />
                        <Input
                            type='number'
                            value={tempFilterOptions?.amountRangeEnd}
                            style={{ height: '40px' }}
                            placeholder='Maximum'
                            onChange={(e) =>
                                setTempFilterOptions({
                                    ...tempFilterOptions,
                                    amountRangeEnd: Number(e.target.value)
                                })
                            }
                        />
                    </div>
                </div>
            )
        },
        {
            key: '5',

            label: (
                <div className='mt-[16px] lg:mt-0'>
                    <label className='text-sm font-medium text-steelBlue block mb-2'>
                        Date
                    </label>
                    <div className='flex items-center gap-[12px]'>
                        <DatePicker
                            placeholder='Start Date'
                            value={
                                tempFilterOptions.from
                                    ? (dayjs(tempFilterOptions.from) as any)
                                    : null
                            }
                            onChange={onChangeFrom}
                            showTime={{ format: 'HH:mm' }}
                            format='YYYY-MM-DD'
                            style={{ width: '100%', height: '40px' }}
                            className='focus:border-2!'
                        />

                        <DatePicker
                            showTime={{ format: 'HH:mm' }}
                            value={
                                tempFilterOptions.to
                                    ? (dayjs(tempFilterOptions.to) as any)
                                    : null
                            }
                            format='YYYY-MM-DD'
                            placeholder='End Date'
                            onChange={onChangeTo}
                            style={{ width: '100%', height: '40px' }}
                        />
                    </div>
                </div>
            )
        },

        {
            key: '6',
            label: (
                <div className='flex justify-between py-4'>
                    <Button
                        text='Cancel'
                        onClick={() => setDropdownVisible(false)}
                        variant='secondaryOutline'
                        size='sm'
                    />
                    <div className='flex gap-[16px]'>
                        <button
                            className='text-steelBlue text-xs leading-[20px]'
                            onClick={() => {
                                setTransactionFilterOptions({
                                    page: 0,
                                    size: 20
                                });
                                setTempFilterOptions({ page: 0, size: 20 });
                            }}
                        >
                            Reset
                        </button>
                        <Button
                            text='Apply Filter'
                            onClick={handleApply}
                            size='sm'
                        />
                    </div>
                </div>
            )
        }
    ];

    const handleButtonClick = () => {
        setDropdownVisible(!dropdownVisible);
    };

    const dropdownItems = items as MenuProps['items'];

    return (
        <>
            <div className='hidden lg:block'>
                <Dropdown
                    menu={{
                        items: dropdownItems,
                        onMouseLeave: (): void => setDropdownVisible(false)
                    }}
                    placement='bottomRight'
                    autoAdjustOverflow={false}
                    trigger={['click']}
                    open={dropdownVisible}
                    overlayStyle={{
                        pointerEvents: 'auto'
                    }}
                    dropdownRender={(menu) => (
                        <div className='w-[375px] h-[467px]'>
                            {React.cloneElement(menu as React.ReactElement)}
                        </div>
                    )}
                >
                    <Button
                        leftIcon={<FilterIcon />}
                        text='Filter'
                        variant='secondaryOutline'
                        onClick={handleButtonClick}
                        size='sm'
                    />
                </Dropdown>
            </div>

            <div className='lg:hidden w-[100vw]'>
                <CustomModal
                    isModalOpen={modalVisible}
                    onClose={() => setModalVisible(false)}
                    hideCloseIcon
                >
                    <div className='w-[85vw] h-[45vh]'>
                        {items?.map((item) => item?.label)}
                    </div>
                </CustomModal>

                <Button
                    leftIcon={<FilterIcon />}
                    text='Filter'
                    variant='tertiary'
                    onClick={() => setModalVisible(true)}
                    size='sm'
                />
            </div>
        </>
    );
};

export default FilterTreasuryTransactions;
